import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Facture } from '../../models/facture.model';
import { Paiement } from '../../models/finance.model';

@Injectable({ providedIn: 'root' })
export class FactureService {

  private base = `${environment.BASE_URL}/api/factures`;

  constructor(private http: HttpClient) {}

  getAll(fermeId: number): Observable<Facture[]> {
    return this.http.get<Facture[]>(this.base, { params: { fermeId } });
  }

  getById(id: number): Observable<Facture> {
    return this.http.get<Facture>(`${this.base}/${id}`);
  }

  create(dto: Facture): Observable<Facture> {
    return this.http.post<Facture>(this.base, dto);
  }

  update(id: number, dto: Facture): Observable<Facture> {
    return this.http.put<Facture>(`${this.base}/${id}`, dto);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`);
  }

  /** Émettre : numéro, PDF figé, archivage, lien de partage, revenu */
  emettre(id: number): Observable<Facture> {
    return this.http.post<Facture>(`${this.base}/${id}/emettre`, {});
  }

  convertir(id: number): Observable<Facture> {
    return this.http.post<Facture>(`${this.base}/${id}/convertir`, {});
  }

  annuler(id: number, motif?: string): Observable<Facture> {
    return this.http.post<Facture>(`${this.base}/${id}/annuler`, {}, { params: motif ? { motif } : {} });
  }

  avoir(id: number, motif?: string): Observable<Facture> {
    return this.http.post<Facture>(`${this.base}/${id}/avoir`, {}, { params: motif ? { motif } : {} });
  }

  paiements(id: number): Observable<Paiement[]> {
    return this.http.get<Paiement[]>(`${this.base}/${id}/paiements`);
  }

  encaisser(id: number, p: Paiement, creerRevenu = true): Observable<Paiement> {
    return this.http.post<Paiement>(`${this.base}/${id}/paiements`, p, { params: { creerRevenu } });
  }

  lienPublic(id: number): Observable<{ url: string }> {
    return this.http.post<{ url: string }>(`${this.base}/${id}/lien-public`, {});
  }

  revoquerLien(id: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}/lien-public`);
  }

  designations(fermeId: number): Observable<{ description: string; prixUnitaire?: number; unite?: string; utilisations: number }[]> {
    return this.http.get<any[]>(`${this.base}/designations`, { params: { fermeId } });
  }

  /** PDF : l'original figé à l'émission, sinon un aperçu « brouillon » */
  downloadPdf(id: number): Observable<Blob> {
    return this.http.get(`${this.base}/${id}/pdf`, { responseType: 'blob' });
  }

  /** Aperçu du formulaire en cours (rien n'est enregistré) */
  apercu(dto: Facture): Observable<Blob> {
    return this.http.post(`${this.base}/apercu`, dto, { responseType: 'blob' });
  }
}
